import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
} from "@mui/material";
import Icon from "@mui/material/Icon";
import MDButton from "components/MDButton";
import { useMaterialUIController, setFixedNavbar, setDarkMode } from "context";
import { useLanguage } from "context/LanguageContext";
import SettingsSection from "./components/SettingsSection";

function SwitchRow({ label, description, checked, onChange }) {
  return (
    <Box>
      <FormControlLabel control={<Switch checked={checked} onChange={onChange} />} label={label} />
      <Typography variant="caption" color="text.secondary" display="block" ml={6}>
        {description}
      </Typography>
    </Box>
  );
}

SwitchRow.propTypes = {
  label: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

function GeneralTab() {
  const { t, currentLanguage, changeLanguage } = useLanguage();
  const [controller, dispatch] = useMaterialUIController();
  const { fixedNavbar, darkMode } = controller;

  return (
    <>
      <SettingsSection title={t("stInterface")} description={t("stInterfaceHint")}>
        <FormControl size="small" sx={{ maxWidth: 320 }}>
          <InputLabel>{t("language")}</InputLabel>
          <Select
            value={currentLanguage}
            label={t("language")}
            onChange={(event) => changeLanguage(event.target.value)}
          >
            <MenuItem value="lt">{t("lithuanian")}</MenuItem>
            <MenuItem value="en">{t("english")}</MenuItem>
          </Select>
        </FormControl>
        <SwitchRow
          label={t("lightDark")}
          description={t("themeModeDescription") || "Switch between light and dark interface."}
          checked={darkMode}
          onChange={() => setDarkMode(dispatch, !darkMode)}
        />
        <SwitchRow
          label={t("navbarFixed")}
          description={
            t("navbarFixedDescription") || "Keep the top navigation visible while scrolling."
          }
          checked={fixedNavbar}
          onChange={() => setFixedNavbar(dispatch, !fixedNavbar)}
        />
      </SettingsSection>

      <SettingsSection title={t("stAccount")} description={t("stAccountHint")} last>
        <Box>
          <MDButton
            variant="outlined"
            color="info"
            startIcon={<Icon>password</Icon>}
            onClick={() => {
              window.location.href = "/settings/password_change/";
            }}
          >
            {t("changePassword") || "Change Password"}
          </MDButton>
        </Box>
      </SettingsSection>
    </>
  );
}

export default GeneralTab;
